module.exports = __webpack_public_path__ + "static/media/health.1518e51b.svg";